import React from 'react';
import PropTypes from 'prop-types'

const TopRoutes = ({ topRoutes = [] }) => (
  <React.Fragment>
    <p className="db-card-title">Top Routes</p>
    <div className="row db-card-wrp">
      <div className="col-xs-6">
        <table className="top-routes-table width97">
          <thead>
            <tr>
              <th>Source</th>
              <th>Destination</th>
            </tr>
          </thead>
          <tbody>
            {
              topRoutes.length?
                topRoutes.map((el, i) => (
                  <tr key={'top-routes-'+i}>
                    <td>{el.source_city}</td>
                    <td>{el.destination_city}</td>
                  </tr>
                ))
              : <tr><td colSpan={9} className="table-no-data">No Data Found</td></tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </React.Fragment>
)

TopRoutes.propTypes = {
  topRoutes: PropTypes.array
};

export default TopRoutes;
